/*
 *
 * UserEditPage constants
 *
 */

export const DEFAULT_ACTION = "app/UserEditPage/DEFAULT_ACTION";

/**
 * Get user
 */
export const GET_USER_ACTION = "app/UserEditPage/GET_USER_ACTION";

export const GET_USER_SUCCESS_ACTION =
  "app/UserEditPage/GET_USER_SUCCESS_ACTION";
export const GET_USER_FAILED_ACTION = "app/UserEditPage/GET_USER_FAILED_ACTION";

/**
 * Change user
 */
export const CHANGE_USER_ACTION = "app/UserEditPage/CHANGE_USER_ACTION";
export const CHANGE_USER_FAILED_ACTION =
  "app/UserEditPage/CHANGE_USER_FAILED_ACTION";
export const CHANGE_USER_SUCCESS_ACTION =
  "app/UserEditPage/CHANGE_USER_SUCCESS_ACTION";

/**
 * Change password
 */
export const CHANGE_PASSWORD_ACTION = "app/UserEditPage/CHANGE_PASSWORD_ACTION";
export const CHANGE_PASSWORD_FAILED_ACTION =
  "app/UserEditPage/CHANGE_PASSWORD_FAILED_ACTION";
export const CHANGE_PASSWORD_SUCCESS_ACTION =
  "app/UserEditPage/CHANGE_PASSWORD_SUCCESS_ACTION";

export const CHANGE_PASS_RESET = "app/UserEditPage/CHANGE_PASS_RESET";

/**
 * Language
 */
export const LANGUAGE_ACTION = "app/UserEditPage/LANGUAGE_ACTION";
export const LANGUAGE_FAILED_ACTION = "app/UserEditPage/LANGUAGE_FAILED_ACTION";
export const LANGUAGE_SUCCESS_ACTION =
  "app/UserEditPage/LANGUAGE_SUCCESS_ACTION";

/**
 * Messages
 */

export const GET_PRACTICE_MESSAGES = "app/UserEditPage/GET_PRACTICE_MESSAGES";
export const GET_PRACTICE_MESSAGES_SUCCESS =
  "app/UserEditPage/GET_PRACTICE_MESSAGES_SUCCESS";
export const GET_PRACTICE_MESSAGES_ERROR =
  "app/UserEditPage/GET_PRACTICE_MESSAGES_ERROR";

/**
 * Urls
 */
export const LANGUAGE_URL = "/languages";
export const USER_URL = "/users";
export const CHANGE_USER_URL = "/users";
export const CHANGE_PASSWORD_URL = "/users/password/change";
